import React from "react";
import styles from "./Avatar.module.css";

const DEFAULT_AVATAR = "/images/default_pic.png";

const sizeMap = {
  sm: "sm",
  md: "md",
  lg: "lg",
};

/**
 * Circular avatar image.
 *
 * @param {object}  props
 * @param {string}  [props.src]       - Image URL
 * @param {string}  [props.alt]       - Alt text
 * @param {"sm"|"md"|"lg"} [props.size] - sm (40px) | md (60px) | lg (130px)
 * @param {boolean} [props.online]    - Show green online dot
 * @param {string}  [props.className] - Extra class names
 * @param {function} [props.onClick]  - Click handler
 */
export default function Avatar({
  src,
  alt = "",
  size = "sm",
  online = false,
  className = "",
  onClick,
}) {
  const sizeClass = styles[sizeMap[size]] || styles.sm;

  return (
    <span
      className={`${styles.wrapper} ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter") onClick(e);
            }
          : undefined
      }
    >
      <img
        className={styles.img}
        src={src || DEFAULT_AVATAR}
        alt={alt}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = DEFAULT_AVATAR;
        }}
      />
      {online && <span className={styles.onlineDot} aria-label="Online" />}
    </span>
  );
}
